import { render, staticRenderFns } from "./Sidebar.vue?vue&type=template&id=21953b00&scoped=true&functional=true&"
var script = {}
import style0 from "./Sidebar.vue?vue&type=style&index=0&id=21953b00&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "21953b00",
  null
  
)

export default component.exports